import React from 'react'


export default class DropDownHeading extends React.Component {

    render(){
        return (
            <div className="dropdown-2--heading">
                {this.props.children || this.props.title}
            </div>
        )
    }

}